/**
 * Anzeige der Clip-Kennzahlen — 11.09.2026.
 *
 * Warum es diese Datei gibt: Bis heute stand in jedem Clip des Bestandes
 * "Avg Speed 0.0 km/h" und "Max Speed 0.0 km/h". Nicht weil die Spieler
 * stillstanden, sondern weil das Backend gar kein Tempo berechnen konnte
 * und aus "unbekannt" beim Aufsummieren eine Null wurde. Drei Ansichten
 * zeigten dieselbe Null, jede mit ihrem eigenen `|| 0`.
 *
 * Seit dem Backend-Fix ist unbekannt `null`. Damit daraus nicht wieder
 * eine 0 wird, formatiert diese Stelle — und nur diese — die Zahlen.
 */

export const KEIN_WERT = "—";

/** Zahl oder Strich. `0` ist ein gültiger Wert und bleibt stehen. */
export function zahl(v) {
  return v === null || v === undefined || Number.isNaN(v) ? KEIN_WERT : v;
}

/** Tempo mit Einheit, oder Strich wenn es nicht gemessen werden konnte. */
export function tempo(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return KEIN_WERT;
  return `${Number(v).toFixed(1)} km/h`;
}

/**
 * Erklärt, warum ein Strich dasteht — als `title` an der Zeile.
 * Ohne Feldspuren gibt es weder Spielerzahl noch Tempo: das rohe
 * Tracking kennt nur springende Verfolgungsnummern und Bildpunkte.
 */
export function hinweis(summary) {
  if (!summary) return undefined;
  if (summary.speed_quelle === "feldspuren") {
    const n = summary.num_chains;
    return n
      ? `Aus ${n} Feldspuren gerechnet (Spielerzahl = Median der gleichzeitig verfolgten Spuren)`
      : undefined;
  }
  return "Keine Feldspuren für diesen Clip — ohne sie gibt es keine Meter und damit kein Tempo";
}
